module.exports = __webpack_public_path__ + "static/media/markerBlue.e20d9656.svg";